import { render, staticRenderFns } from "./UpdateStock.vue?vue&type=template&id=6b3d5920&scoped=true"
import script from "./UpdateStock.vue?vue&type=script&lang=js"
export * from "./UpdateStock.vue?vue&type=script&lang=js"
import style0 from "./UpdateStock.vue?vue&type=style&index=0&id=6b3d5920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3d5920",
  null
  
)

export default component.exports